const EndPoints = {
  featureFlag:"config/funeral/status",
  login: "/login/login",
  otp: "/login/verify",
  policy: "/v1/policies",
  caseCreationPolicy: "/v1/policies/internal",
  claim: "/v1/claim",
  createClaim: "/v1/claim/create",
  createClaimForTenPercent: "/v1/claim/create/ten-percent",
  getAllClaims: "v1/claim/get-all",
  getAllCases:"/v1/cases/getAllCases",
  searchCases: "/v1/cases/search",
  getAllBodyRemovals:"/v1/body-removals",
  searchBodyRemovals: "/v1/body-removals/search",
  createRemovalOrder:"/v1/body-removals",
  acceptDispatch:"/v1/body-removals",
  markDriverEnRoute:"/v1/body-removals",
  markArrivedAtScene:"/v1/body-removals",
  confirmBodyCollection:"/v1/body-removals",
  markArrivedAtMortuary:"/v1/body-removals",
  downloadBodyRemovalDocument:"/v1/body-removals",
  getMortuaryRecords: "/v1/mortuary-records",
  getMortuaryRecordByBodyRemoval: "/v1/mortuary-records/by-body-removal",
  getMortuaryHistory: "/v1/mortuary-records",
  registerMortuaryIntake: "/v1/mortuary-records/by-body-removal",
  updateMortuaryMeasurement: "/v1/mortuary-records",
  startMortuaryStage: "/v1/mortuary-records",
  completeMortuaryStage: "/v1/mortuary-records",
  updateMortuaryStage: "/v1/mortuary-records",
  getMortuaryTemperatureLogs: "/v1/mortuary-records/temperature-logs",
  getMortuaryStorageUnits: "/v1/mortuary-records/storage-units",
  getMortuaryCapacities: "/v1/mortuary-records/capacity",
  getMortuaryHygieneChecklists: "/v1/mortuary-records/hygiene-checklists",
  getBodyDispatches: "/v1/body-dispatches",
  createInternalTransfer: "/v1/body-dispatches/internal-transfer",
  submitInternalTransfer: "/v1/body-dispatches",
  receiveInternalTransfer: "/v1/body-dispatches",
  requestMovementApproval: "/v1/body-dispatches",
  decideMovementApproval: "/v1/body-dispatches",
  acknowledgeMovement: "/v1/body-dispatches",
  createExternalParlourRelease: "/v1/body-dispatches/external-parlour",
  releaseExternalParlour: "/v1/body-dispatches",
  createFamilyDelivery: "/v1/body-dispatches/family-delivery",
  completeFamilyDelivery: "/v1/body-dispatches",
  markBodyDispatchEasipolUploaded: "/v1/body-dispatches",
  uploadOperationalSignature: "/v1/signatures/upload",
  downloadOperationalSignature: "/v1/signatures/download",
  getWarehousePreparations: "/v1/warehouse/preparations",
  getWarehouseMaterialChecklists: "/v1/warehouse/material-checklists",
  requestWarehouseDispatchApproval: "/v1/warehouse/material-checklists",
  decideWarehouseDispatchApproval: "/v1/warehouse/material-checklists",
  getWarehouseBrokenLossReports: "/v1/warehouse/broken-loss-reports",
  getWarehouseStockTakes: "/v1/warehouse/stock-takes",
  getWarehouseCleaningRosters: "/v1/warehouse/cleaning-rosters",
  getInventoryMaterials: "/v1/inventory/materials",
  lookupInventoryMaterials: "/v1/inventory/materials/lookup",
  resolveInventoryMaterials: "/v1/inventory/materials/resolve",
  getInventoryDashboard: "/v1/inventory/dashboard",
  getInventoryMovements: "/v1/inventory/movements",
  getInventoryMovementHistory: "/v1/inventory/movements/history",
  previewInventoryImport: "/v1/inventory/materials/import/preview",
  importInventoryMaterials: "/v1/inventory/materials/import",
  allocateInventoryMaterial: "/v1/inventory/allocate",
  releaseInventoryReservation: "/v1/inventory/release-reservation",
  adjustInventoryMaterial: "/v1/inventory/adjust",
  getFuneralPackageCatalog: "/v1/funeral-packages",
  getFuneralPlanningByCase: "/v1/funeral-planning/case",
  getFuneralPlanningByCaseNumber: "/v1/funeral-planning/case-number",
  updateFuneralPlanningByCase: "/v1/funeral-planning/case",
  funeralPlanning: "/v1/funeral-planning",
  specialServices: "/v1/special-services",
  ensureFuneralPlanningByCase: "/v1/funeral-planning/case",
  syncAssignedFuneralPlans: "/v1/funeral-planning/sync-assigned-cases",
  getNotifications: "/v1/notifications",
  markNotificationRead: "/v1/notifications",
  streamNotifications: "/v1/notifications/stream",
  getAllQuotations:"/v1/quotations/getAllQuotations",
  quotations:"/v1/quotations",
  getQuotableItems:"/v1/catalogue/quotable-items",
  catalogueItems:"/v1/catalogue/items",
  catalogueBranches:"/v1/catalogue/branches",
  catalogueAdmin:"/v1/catalogue/admin",
  setQuotationLineItems:"/v1/quotations",
  getInvoices:"/v1/invoices",
  getInvoiceDetails:"/v1/invoices",
  issueInvoice:"/v1/invoices",
  invoicesBase:"/v1/invoices",
  paymentsBase:"/v1/payments",
  financeExportEvents:"/v1/finance/export-events",
  aods:"/v1/aods",
  casesBase:"/v1/cases",
  getAllCatering:"/v1/catering/getAllCatering",
  getAllTombstones:"/v1/tombstone/getAllTombstones",
  deliverBodyRemoval: "/v1/body-removals",
  getCateringMenuItems:"/v1/catering/menu-items",
  assignMe: "/v1/claim/assign",
  changeClaimAssignment: "/v1/claim/assignment",
  getUserRoles: "users",
  getClaimDetails: "v1/claim",
  getCaseDetails:"/v1/cases",
  getBodyRemovalDetails:"/v1/body-removals",
  getQuotationDetails:"/v1/quotations",
  getCateringDetails:"v1/catering",
  getTombstoneDetails:"/v1/tombstone",
  updateCateringDetails:"/v1/catering",
  updateTombstoneDetails:"/v1/tombstone",
  confirmCateringDetails:"/v1/catering",
  confirmTombstoneDetails:"/v1/tombstone",
  getClaimHistory: "v1/claim-history",
  getClaimNotifications: "v1/claim",
  getCaseHistory: "/v1/case-history",
  getBodyRemovalHistory: "/v1/case-history/body-removal-history",
  getCateringHistory: "/v1/case-history/catering-history",
  getDriverHistory: "/v1/case-history/driver-history",
  getVehicleHistory: "/v1/case-history/vehicle-history",
  claimSubmit: "v1/claim/submit",
  claimStatus: "/v1/claim/status",
  closeClaim: "/v1/claim/close",
  getBranchName: "/v1/branch",
  getAllFilteredClaims: "/v1/claim/get-by-status",
  updateClaim: "/v1/claim/update",
  updateTenPercentClaim: "/v1/claim/update/ten-percent",
  getAllBanks: "/v1/get-all-banks",
  getAllRelations: "/v1/get-all-relations",
  getAllCountries: "/v1/get-all-countries",
  benefitDetails: "/v1/claim/claim-benefit",
  benefitOverride: "/v1/claim",
  paymentHistory: "v1/transaction/history",
  searchClaim: "/v1/claim/search",
  getOtp: "/otp/send",
  verifyOtp: "otp/verify",
  cognitoLogin: "https://cognito-idp.af-south-1.amazonaws.com/",
  getUser: "/users/getUser",
  getDocument: "/v1/claim/",
  deleteDocument:"/v1/claim/",
  uploadUnderwriterDoc: "/v1/claim/upload/underwriter-document",
  generateReport:"/v1/generate-csv",
  downloadReport:'/v1/download',
  reportHistory:'/v1/history',
  proofOfPayment:'/v1/csv-batch/upload-documents',
  claimBenefit:"/v1/claim/",

  // case creation
  createCase:"/v1/cases/manualCaseCreation",
  assignCase: "/v1/cases/assignCase",
  funeralPlanners: "/v1/cases/funeral-planners",
  submitCase:"/v1/cases/submit",
  updateCase:"/v1/cases/update",
  uploadDocs:"/v1/cases/upload/case-document",
  monthlyStats: "/reports/monthly-stats",
  dateRangeStats: "/date-reports/range",
  agedClaimsAnalysis: "/aged-claims/analysis",
  getAllClaimsData:"/v1/claims-executive-reports",
  exportClaimsReport: "/v1/claims/export",
  easipolReconciliation: "/v1/easipol-reconciliation",

  //fleet Management
  getAllVehicles:"/v1/vehicles/getAllVehicles",
  getAllDrivers:"/v1/drivers/getAllDrivers",
  getAvailableDrivers: "/v1/drivers/getAvailableDrivers",
  getAvailableVehicles: "/v1/vehicles/getAvailableVehicles",
  addVehicle:"/v1/vehicles/addVehicles",
  addDriver:"/v1/drivers/addDrivers",
  fetchVehicleDetails:"/v1/vehicles",
  updateVehicleDetails:"/v1/vehicles",
  fetchDriverDetails:"/v1/drivers",
  updateDriverDetails:"/v1/drivers",
  DeleteVehicle:"/v1/vehicles",
  DeleteDriver:"/v1/drivers",
  allocateResources:"/v1/body-removals/allocate-resources",
  getBodyRemovalResourceRecommendations: "/v1/body-removals",
  allManufacturer: "/v1/vehicles/manufacturers",
  allModals:"/v1/vehicles/models",
  assignVehicle:"/v1/body-removals/vehicles/assignVehicle",
  assignDriver:"/v1/body-removals/drivers/assignDriver",
  completeFuneralFleetAllocation:"/v1/body-removals/fleet-allocations",
  driverAssignments:"/v1/drivers",
  getFleetPortal: "/v1/fleet/portal",
  getFleetBranches: "/v1/fleet-branches",
  getNearestFleetBranch: "/v1/fleet-branches/nearest",
  operationalLocations: "/v1/operational-locations",
  recordFleetMileage: "/v1/fleet/vehicles",
  syncCartrackMileage: "/v1/fleet/vehicles",
  getFleetBodyTransfers: "/v1/fleet/body-transfers",
  getFleetReportSummary: "/v1/fleet/reports/summary",

  // memorials
  memorialLocations: "/v1/memorials/locations",
  memorialPlots: "/v1/memorials/plots",
  memorialEnquiries: "/v1/memorials/enquiries",
  memorialAppointments: "/v1/memorials/appointments",
  memorialAvailableSlots: "/v1/memorials/appointments/available-slots",
  memorialTimeSlots: "/v1/memorials/time-slots",
  memorialApplications: "/v1/memorials/applications",
  memorialDashboard: "/v1/memorials/dashboard",
  memorialReports: "/v1/memorials/reports"
};

export default EndPoints;
